module.exports = __webpack_public_path__ + "img/cpzz3@2x.f15a649a.png";